import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import Gbtn from "../../../Components/buttons/Gbtn";
import DashNav from "../../../Components/DashNav/DashNav";
import { FiEdit } from "react-icons/fi";
import { RiSignalWifiErrorLine, RiDeleteBin6Line } from "react-icons/ri";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../Components/LoadingSpinner/LoadingSpinner";
import noImage from "../../../Assests/avatar1.png";
import CatageorySVG from "../../../Components/SVGS/CatageorySVG";
import { getAllCatageory } from "../../../api";

function Roles() {
  const icon = () => {
    return <CatageorySVG size="26" fill="#DF2F35" />;
  };

  const location = useLocation();
  const CurrPage =
    location.state && location.state ? location.state.page : null;

  const navigate = useNavigate("");
  const addOnclick = () => {
    navigate("/dashboard/newsEventCatageory/add");
  };

  const [page, setPage] = useState(CurrPage !== null ? CurrPage : 1);
  const [limit, setLimit] = useState(10);
  const [totalRecords, setTotalRecords] = useState(10);
  const [catageories, setCatageories] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [paginationDisplay, setPaginationDisplay] = useState("block");
  const [err, setErr] = useState(false);
  const [searchString, setSearchString] = useState("");

  const arr = [
    {
      id: 4,
      image_path: "../../../Assests/profile2.jpeg",
      name: "hammad",
      link: "url/hhtp/dkenyx33%662df",
    },
  ];

  // console.log("npage", CurrPage);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    // setPage(CurrPage !== null ? CurrPage : page);
    fetchData(page);
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => {
      if (searchString.trim() !== "") fetchData(page, searchString);
    }, 1500);
    return () => {
      clearTimeout(delay);
    };
  }, [searchString]);

  const fetchData = (pageNumber, searchTxt) => {
    setisLoading(true);
    setErr(false);
    getAllCatageory(limit, pageNumber, searchTxt)
      .then(({ data }) => {
        setisLoading(false);
        if (data.success) {
          setCatageories(data.result);
          setTotalRecords(data.total_records);
          setPaginationDisplay("block");
          setPage(pageNumber);
        } else {
          if (data.error_code === 2) {
            setCatageories(data.result);
            setErrorMsg(data.message);
          } else {
            setErr(true);
            setErrorMsg(data.message);
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
        setErr(true);
        setPaginationDisplay("none");
        setisLoading(false);
        setErrorMsg(err.message);
      });
  };

  const handlePageChange = (pageNumber) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    if (pageNumber >= 1) {
      setPage(pageNumber);
      fetchData(pageNumber, searchString);
    }
  };

  const handleSearch = (e) => {
    setSearchString(e.target.value);
    if (e.target.value === "") {
      fetchData(page);
    }
  };

  return (
    <>
      <div className="mainDashView">
        <div>
          <DashNav svg={icon} DashboardNavText="News & Events Catageory" />
        </div>

        <div className="dashPanel border-lt-Gray">
          <div className="r-ViewBar">
            <div className="r-ViewBar2">
              <div>
                <input
                  type="search"
                  value={searchString}
                  onChange={handleSearch}
                  placeholder="Search"
                  className="rolesSearch"
                />
              </div>
            </div>
            <div className="r-View-btn">
              <Gbtn
                text="Add"
                color="#DF2F35"
                radius="5px"
                width="200px"
                func={addOnclick}
              />
            </div>
          </div>
          {isLoading ? (
            <LoadingSpinner />
          ) : err ? (
            <div className="network-err-msg">
              <RiSignalWifiErrorLine /> {errorMsg}
            </div>
          ) : catageories && catageories.length !== 0 ? (
            <div className="tableContainer">
              <table className="roleViewTable" style={{ minWidth: "450px" }}>
                <thead>
                  <tr>
                    <th>Actions</th>
                    <th>Photo</th>
                    <th>Name</th>
                  </tr>
                </thead>
                <tbody>
                  {catageories.map((data) => (
                    <Rows data={data} currentPage={page} />
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="network-err-msg">{errorMsg}</div>
          )}
          <div className="paginationDiv" style={{ display: paginationDisplay }}>
            <Pagination
              activePage={page}
              itemsCountPerPage={limit}
              totalItemsCount={totalRecords}
              pageRangeDisplayed={3}
              onChange={(pageNumber) => {
                handlePageChange(pageNumber);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
const Rows = ({ data, currentPage }) => {
  const navigate = useNavigate();
  const editRole = () => {
    navigate("/dashboard/newsEventCatageory/edit", {
      state: { catageoryToEdit: data, currentPage: currentPage },
    });
  };
  const delRole = () => {
    navigate("/dashboard/newsEventCatageory/delete", {
      state: { catageoryToEdit: data, currentPage: currentPage },
    });
  };

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [imgErr, setImgErr] = useState(false);

  const handleImageErr = () => {
    setImgErr(true);
  };

  return (
    <>
      {data && data ? (
        <tr>
          <td
            style={{
              display: "flex",
              justifyContent: "center",
              minWidth: "60px",
            }}
          >
            <button onClick={editRole} className="Actionbtn editBtn">
              <FiEdit />
            </button>
            <button onClick={delRole} className="Actionbtn delBtn">
              <RiDeleteBin6Line />
            </button>
          </td>
          <td>
            <img
              src={imgErr ? noImage : baseUrl + data.image_path}
              onError={handleImageErr}
              alt=""
              height={"34"}
              width={"34"}
              style={{
                borderRadius: "100%",
                border: "1px solid lightgray",
                borderBlockColor: "lightgray",
              }}
            />
          </td>
          <td>{data.name}</td>
        </tr>
      ) : null}
    </>
  );
};

export default Roles;
